export default __webpack_public_path__ + "static/media/Tools-P3-CIFOR.5b5afa53.jpg";